export default "__VITE_ASSET__BmdBLnlW__"